<h2 mat-dialog-title class="flex items-center gap-3 text-xl font-bold mb-4 px-6 py-4 border-b">
  <mat-icon class="text-blue-600">business</mat-icon>
  <span>{{ data.currentLogoUrl ? 'Actualizar Logo' : 'Agregar Logo' }} - {{ data.companyName }}</span>
</h2>

<mat-dialog-content class="!px-0 !py-0">
  <div class="p-5">
  <!-- Progreso de carga -->
  <div *ngIf="isUploading" class="mb-4">
    <mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
    <p class="text-center text-gray-600">Subiendo logo...</p>
  </div>

  <!-- Vista previa del logo actual -->
  <div *ngIf="data.currentLogoUrl && !selectedFile" class="mb-6">
    <h3 class="text-lg font-medium mb-3">Logo Actual</h3>
    <div class="flex justify-center p-4 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
      <img
        [src]="data.currentLogoUrl"
        [alt]="'Logo de ' + data.companyName"
        class="max-h-32 max-w-48 object-contain"
        (error)="$event.target.src = 'assets/images/placeholder-logo.png'"
      >
    </div>
  </div>

  <!-- Vista previa del nuevo logo -->
  <div *ngIf="previewUrl && selectedFile" class="mb-6">
    <h3 class="text-lg font-medium mb-3">Vista Previa del Nuevo Logo</h3>
    <div class="flex justify-center p-4 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
      <img
        [src]="previewUrl"
        [alt]="'Vista previa del logo'"
        class="max-h-32 max-w-48 object-contain"
      >
    </div>
  </div>

  <!-- Zona de carga de archivos -->
  <div class="mb-6">
    <h3 class="text-lg font-medium mb-3">
      {{ selectedFile ? 'Cambiar Archivo' : 'Seleccionar Archivo' }}
    </h3>

    <div
      class="border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-all duration-300 bg-gray-50 hover:border-blue-600 hover:bg-blue-50"
      [class.border-blue-600]="dragOver"
      [class.bg-blue-50]="dragOver"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onFileDrop($event)"
      (click)="openFileSelector()"
    >
      <div class="flex flex-col items-center gap-4">
        <mat-icon class="text-blue-600 text-5xl">cloud_upload</mat-icon>

        <div>
          <p class="font-medium text-gray-700 mb-1">
            Arrastra tu logo aquí o haz clic para seleccionar
          </p>
          <p class="text-sm text-gray-500">
            Formatos: PNG, JPG, JPEG | Tamaño máximo: 20MB
          </p>
        </div>

        <div *ngIf="selectedFile" class="mt-2 p-2 bg-white rounded border">
          <p class="text-sm font-medium">{{ selectedFile.name }}</p>
          <p class="text-xs text-gray-500">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</p>
        </div>
      </div>

      <input
        #fileInput
        type="file"
        accept="image/*"
        class="hidden"
        (change)="onFileSelected($event)"
      />
    </div>
  </div>

  <!-- Información adicional -->
  <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
    <div class="flex items-start gap-3">
      <mat-icon class="text-blue-600 mt-0.5">info</mat-icon>
      <div class="text-sm text-blue-800">
        <p class="font-medium mb-1">Recomendaciones:</p>
        <ul class="list-disc list-inside space-y-1">
          <li>Usa imágenes con fondo transparente (PNG) para mejores resultados</li>
          <li>Dimensiones recomendadas: 200x200 píxeles o mayor</li>
          <li>Mantén una relación de aspecto cuadrada o rectangular</li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end gap-3 px-6 py-4 border-t">
  <button
    mat-button
    (click)="close()"
    [disabled]="isUploading"
    class="text-gray-600"
  >
    Cancelar
  </button>

  <button
    *ngIf="selectedFile && !isPreviewMode"
    mat-button
    color="warn"
    (click)="removeLogo()"
    [disabled]="isUploading"
    class="text-red-600"
  >
    <mat-icon class="mr-1">delete</mat-icon>
    Quitar Selección
  </button>

  <button
    mat-raised-button
    color="primary"
    (click)="updateLogo()"
    [disabled]="!selectedFile || isUploading"
    class="bg-blue-600 text-white"
  >
    <mat-icon class="mr-1">{{ data.currentLogoUrl ? 'update' : 'upload' }}</mat-icon>
    {{ data.currentLogoUrl ? 'Actualizar Logo' : 'Subir Logo' }}
  </button>
</mat-dialog-actions>